import React from "react";
import Sidebar from "./Sidebar";

interface LayoutProps {
    children: React.ReactNode;
    roles: string[];
    isSubcontractor?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ children, roles, isSubcontractor = false }) => {
    return (
        <div style={{
            display: "flex",
            minHeight: "100vh",
            backgroundColor: "#f5f5f5",
        }}>
            <Sidebar roles={roles} isSubcontractor={isSubcontractor} />
            <main style={{
                marginLeft: "220px",
                flex: 1,
                padding: "32px",
            }}>
                {children}
            </main>
        </div>
    );
};

export default Layout;